import { GraphQLClient } from 'graphql-request'
import { GRAPHQL_HOST } from 'src/config/config'
import { alspBySlugCustom } from './alspBySlugCustom'
import type { FetchPublishedVendor } from './attachPublishedVendor'
import { consultancyBySlugCustom } from './consultancyBySlugCustom'
import { createEnhancedLoggingWrapper } from './customWrapper'
import { getSdk, type Sdk } from './generated/requests'
import { productBySlugCustom } from './productBySlugCustom'

function createApolloSdk(): Sdk {
  const client = new GraphQLClient(GRAPHQL_HOST!)
  const withWrapper =
    process.env.NEXT_PUBLIC_SHOW_REQUEST_LOG == 'true' ? createEnhancedLoggingWrapper() : undefined
  const sdk = getSdk(client, withWrapper)
  const baseProductBySlug = sdk.productBySlug.bind(sdk)
  const baseAlspBySlug = sdk.alspBySlug.bind(sdk)
  const baseConsultancyBySlug = sdk.consultancyBySlug.bind(sdk)

  const fetchPublishedVendor: FetchPublishedVendor = async (documentId, requestHeaders) => {
    const result = await sdk.publishedVendorByDocumentId({ documentId }, requestHeaders)
    return result.vendor ?? null
  }

  return {
    ...sdk,
    productBySlug: (variables, requestHeaders) =>
      productBySlugCustom(baseProductBySlug, variables, requestHeaders, fetchPublishedVendor),
    alspBySlug: (variables, requestHeaders) =>
      alspBySlugCustom(baseAlspBySlug, variables, requestHeaders, fetchPublishedVendor),
    consultancyBySlug: (variables, requestHeaders) =>
      consultancyBySlugCustom(baseConsultancyBySlug, variables, requestHeaders, fetchPublishedVendor),
  }
}

export const apolloSdk = createApolloSdk()
